module.exports = __webpack_public_path__ + "static/media/dawid-camdrone.66532453.webp";